// src/components/Button.jsx

import PropTypes from "prop-types";

import GlassButton from "./ui/GlassButton";

const Button = ({ id, title, rightIcon = null, leftIcon = null, containerClass = "", onClick = () => {} }) => {
  return (
    <GlassButton
      id={id}
      className={containerClass}
      onClick={onClick}
      variant="cyan"
      size="sm"
    >
      {leftIcon && <span className="mr-2 flex-shrink-0">{leftIcon}</span>}
      <span className="relative inline-flex overflow-hidden font-sans uppercase flex-grow">
        {title}
      </span>
      {rightIcon && <span className="ml-2 flex-shrink-0">{rightIcon}</span>}
    </GlassButton>
  );
};

Button.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  rightIcon: PropTypes.element,
  leftIcon: PropTypes.element,
  containerClass: PropTypes.string,
  onClick: PropTypes.func,
};



export default Button;
